import { API_BASE } from '../config/api';

async function safeJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
}

export async function fetchGallery(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    usp.set(k, String(v));
  });
  const qs = usp.toString();
  const res = await fetch(`${API_BASE}/gallery${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to load gallery');
  return await safeJson(res);
}

export async function uploadGalleryImages(formData) {
  const res = await fetch(`${API_BASE}/gallery`, { method: 'POST', body: formData });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Upload failed');
  return await safeJson(res);
}

export async function deleteGalleryItem(id) {
  const res = await fetch(`${API_BASE}/gallery/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Delete failed');
  return await safeJson(res);
}
